import { forwardRef } from 'react';
import styles from './multi-select.module.css';
import { cn } from '../../../../utils';
import { BaseOption, RenderOptionProps } from './types';

function OptionComponent<Option extends BaseOption>(
  { label, highlighted, itemProps }: RenderOptionProps<Option>,
  ref: React.Ref<HTMLButtonElement>,
) {
  return (
    <button
      type="button"
      ref={ref}
      className={cn(styles.option, highlighted && 'active')}
      {...itemProps}
    >
      {label}
    </button>
  );
}

export const Option = forwardRef(OptionComponent) as <
  Option extends BaseOption,
>(
  props: RenderOptionProps<Option> & { ref?: React.Ref<HTMLElement> },
) => ReturnType<typeof OptionComponent>;

export function defaultRenderOption<Option extends BaseOption>(
  props: RenderOptionProps<Option>,
) {
  return <Option {...props} />;
}
